import moment from 'moment';

const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Paramter is of the form '2018-05-04'
// Expects a Sunday date
const buildWeek = (date: string, currentMonth: Object) => {
  const first7days = [];
  const toAdd = moment(date, 'YYYY-MM-DD');
  // Build the week from Sunday to Saturday
  let nextDay = toAdd;
  for (let x = 0; x <= 6; x += 1) {
    const isCurrentMonth = moment(nextDay).isSame(currentMonth, 'month');
    const nextDayPayload = {
      formatted: nextDay.format('YYYY-MM-DD'),
      day: nextDay.format('ddd'),
      dayOfMonth: nextDay.format('D'),
      currMonth: nextDay.format('MMM'),
      currYear: nextDay.format('YYYY'),
      monthNumber: nextDay.format('MM'),
      isCurrentDeliveryDate: false,
      isSelected: false,
      isAvailable: false,
      isCurrentMonth,
    };
    first7days[daysOfWeek.indexOf(nextDay.format('ddd'))] = nextDayPayload;
    nextDay = toAdd.add(1, 'days');
  }
  return first7days;
};

const buildCurrentMonth = (first7days: Array, monthToBuild: Object) => {
  const currentMonth = [];
  let dateMoment = moment(first7days[6].formatted);
  let nextDay = dateMoment.add(1, 'days');
  let formattedNextDay = nextDay.format('YYYY-MM-DD');
  // Push first 7 days to currentMonth array
  currentMonth[0] = first7days;
  // Build and Push the rest of the weeks of currentMonth starting with the day after the first7days
  for (let x = 1; x <= 5; x += 1) {
    currentMonth[x] = buildWeek(formattedNextDay, monthToBuild);
    formattedNextDay = currentMonth[x][6].formatted;
    // Break if month ends between Sunday and Friday
    if (!currentMonth[x][6].isCurrentMonth) {
      break;
    }
    // Break if month ends in a Saturday - check if Next day is new month
    dateMoment = moment(formattedNextDay, 'YYYY-MM-DD');
    nextDay = dateMoment.add(1, 'days');
    if (currentMonth[x][6].monthNumber !== nextDay.format('MM')) {
      break;
    }
    formattedNextDay = nextDay.format('YYYY-MM-DD');
  }
  return currentMonth;
};

// Paramter is of the form '2018-05-04'
// Will use the number of the week to get Sunday's date and pass it to buildWeek`
const buildFirstWeekOfMonth = (firstDayOfMonth: string) => {
  const currentMonth = moment(firstDayOfMonth);
  const weekNumber = moment(firstDayOfMonth).format('W');
  let firstDayOfWeek;
  if (moment(firstDayOfMonth).format('dddd') !== 'Sunday') {
    firstDayOfWeek = moment(firstDayOfMonth)
      .day('Sunday')
      .week(weekNumber);
  } else {
    firstDayOfWeek = moment(firstDayOfMonth);
  }
  const first7days = buildWeek(
    firstDayOfWeek.format('YYYY-MM-DD'),
    currentMonth
  );
  return first7days;
};

const getNumberOfMonthsToBuild = (startMonth: number, endMonth: number) => {
  if (endMonth > startMonth) {
    return endMonth - startMonth;
  }
  if (endMonth < startMonth) {
    return 12 - startMonth + endMonth;
  }
  return 0;
};

const createCalendarData = (currentDeliveryDate: string, endMonth: number) => {
  const Calendar = {};
  const startMoment = moment(currentDeliveryDate);
  const currentMoment = moment(currentDeliveryDate);
  const startMonth = startMoment.month();
  // Gets number of months the calendar should render
  const numberOfMonths = getNumberOfMonthsToBuild(startMonth, endMonth);
  // Create calendar with given number of months to display
  for (let x = 0; x <= numberOfMonths; x += 1) {
    const firstDayOfMonth = currentMoment.startOf('month').format('YYYY-MM-DD');
    const firstWeek = buildFirstWeekOfMonth(firstDayOfMonth);
    Calendar[currentMoment.month()] = buildCurrentMonth(
      firstWeek,
      currentMoment
    );
    currentMoment.add(1, 'month');
  }
  console.log(Calendar);
  return Calendar;
};

export default createCalendarData;
